'use client'

import * as React from 'react'
import { Check, ChevronsUpDown } from 'lucide-react'
import { cn } from '@/lib/utils'
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
} from '@/components/ui/command'
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover'
import { Button } from '@/components/ui/button'

export function Combobox({
  options = [],
  field,
  searchKey = 'label',
  placeholder = 'Search...',
  className = '',
  contentClassName = '', // New prop for PopoverContent styling
  icon: Icon, // 👈 accept any icon component
}) {
  const [open, setOpen] = React.useState(false)

  const selectedOption = options.find((option) => option.value === field?.value)

  const handleSelect = (value) => {
    field?.onChange?.(value)
    setOpen(false)
  }

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          role="combobox"
          aria-expanded={open}
          className={cn('w-full justify-between', className)}
        >
          {selectedOption?.[searchKey] || placeholder}
          {/* Render icon only if provided */}
          {Icon && <Icon className="ml-2 h-4 w-4 shrink-0 opacity-50" />}
        </Button>
      </PopoverTrigger>
      <PopoverContent
        className={cn('w-full p-0', contentClassName)} // Apply contentClassName
        style={{ maxHeight: 'var(--radix-popover-content-available-height)', overflowY: 'auto' }} // Dynamic max-height and scrolling
      >
        <Command>
          <CommandInput placeholder={placeholder} />
          <CommandEmpty>No results found.</CommandEmpty>
          <CommandGroup>
            {options.map((option) => (
              <CommandItem key={option.value} onSelect={() => handleSelect(option.value)}>
                <Check
                  className={cn(
                    'mr-2 h-4 w-4',
                    field?.value === option.value ? 'opacity-100' : 'opacity-0'
                  )}
                />
                {option[searchKey]}
              </CommandItem>
            ))}
          </CommandGroup>
        </Command>
      </PopoverContent>
    </Popover>
  )
}
